import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { MnnItem } from '../../../models/mnn-item';
import { MnnResponse } from '../../../models/mnn-response';
import { NgxSpinnerService } from 'ngx-spinner';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-modal-mnn',
  templateUrl: './modal-mnn.component.html',
  styleUrls: ['./modal-mnn.component.sass']
})
export class ModalMnnComponent implements OnInit {
  http: HttpClient;

  dataMnn: Array<MnnItem>;
  sortColumnName: string = "isGrotex";
  sortColumnType: "asc" | "desc" = "asc";
  filterMnn: string = null;
  
  lastSortColumnName: string
  lastAuctionId: string

  spinner: NgxSpinnerService;

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService) {
    this.http = _http;
    this.spinner = _spinner;
  }

  ngOnInit() {
    $('#modalMnnComponent').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalMnnComponent').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  sort(colName: string){
    this.sortColumnName = colName

    if (this.lastSortColumnName == this.sortColumnName) {
      if (this.sortColumnType == "asc") {
        this.sortColumnType = "desc"
      } else {
        this.sortColumnType = "asc"
      }
    } else {
      this.sortColumnType = "asc"
    }
    this.loadMnn(this.lastAuctionId)
  }

  onFieldChange(){
    this.filterMnn = $('#textMnnName').val().toString()
    this.loadMnn(this.lastAuctionId)
  }

  
  public loadMnn(IDAuction){
    this.spinner.show();
    this.lastAuctionId = IDAuction
    this.dataMnn = new Array<MnnItem>();
    let mnnResponse: MnnResponse = {
      idAuction: IDAuction,
      filterMnn: this.filterMnn,
      sortColumnName: this.sortColumnName,
      sortColumnType: this.sortColumnType
    }

    this.http.post<Array<string>>(apiServer + "/mnn/info", mnnResponse, {})
    .subscribe(resp => { 
      for (let index = 0; index < resp.length; index++) {
        this.dataMnn[index] = { isGrotex: resp[index]['isGrotex'], mnnName: resp[index]['mnnName'], nmc: resp[index]['nmc'], persentage: resp[index]['persentage'], rowColor: resp[index]['rowColor'] }; 
      }
      this.lastSortColumnName = mnnResponse.sortColumnName
      this.spinner.hide()
    });

    this.updateSortIcons()
  }

  private updateSortIcons() {
    let colums = $.makeArray($('.sorted-colums'))
    colums.forEach(header => {
      header.classList.remove('asc', 'desc');
      header.classList.add('no-sort');
    });

    if (this.sortColumnName != null) {
      const currentHeaders = $.makeArray($(`#${this.sortColumnName}`))
      currentHeaders.forEach(el => {
        el.classList.remove('no-sort')
        el.classList.add(this.sortColumnType)
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-mnn/modal-mnn.component.ts